import React from 'react';
import { config } from '@triare/auth-redux';
import ForgotPasswordContent from '../../../components/Pages/Auth/ForgotPassword';
import Simple from '../../../components/Layout/Simple';

const { displayName } = config;

export default function ForgotPassword(): React.ReactNode {
  document.title = `${displayName}: Forgot password`;

  return (
    <Simple>
      <ForgotPasswordContent />
    </Simple>
  );
}
